
const details =[
    {
        id: 1,
        icon: '/f1.svg', // Update paths to start from the root
        title: 'Vendor Onboarding',
        content: 'Buyers can intimate the forecast to vendors and get confirmation.',
      },
    {
        id:2,
        icon:'/f2.svg',
        title:'Request for Quote',
        content:'Compare vendor quotes to optimize procurement.',
    },
    {
        id:3,
        icon:'/f3.svg',
        title:'Manage Purchase Orders',
        content:'Vendor can view the purchase orders & he can either confirm or reject.',
    },
    {
        id:4,
        icon:'/f4.svg',
        title:'Advanced shipping Notice',
        content:'Vendor can view the purchase orders & he can either confirm or reject.',
    },
    {
        id:5,
        icon:'/f5.svg',
        title:'Quality Inspection',
        content:'Quality check for both raw materials and finished goods can be captured.',
    },
    {
        id:6,
        icon:'/f6.svg',
        title:'Invoice Tracking',
        content:'Enables businesses to keep a track ofboth the payments & expenses.',
    },
    {
        id:7,
        icon:'/f7.svg',
        title:'Goods receipt tracking',
        content:'Vendors gets acknowledged once buyers receive Goods.',
    },
    {
        id:8,
        icon:'/f5.svg',
        title:'Payment tracking',
        content:'Effective Automatic Mail triggers to notify the stakeholders on important transaction.',
    },
    {
        id:9,
        icon:'/f9.svg',
        title:'Ticketing System',
        content:'Efficiently manage & resolve various issues / incidents related to their vendors',
    },
    {
        id:10,
        icon:'/f10.svg',
        title:'SAP & ERP Integration',
        content:'Vendor performance evaluated based on QDC (quality / delivery / cost)',
    },
    {
        id:11,
        icon:'/f11.svg',
        title:'Analytics & dashboard',
        content:'Dashboard with interactive visual analytics help you to make intelligent',
    },
    {
        id:12,
        icon:'/f1.svg',
        title:'Reports',
        content:'Decision making. Maintains a seamless Buyer - Vendor Relationship Management',
    }
]

export default details;